import axios from "axios";
import { API } from "./uploads";

export async function getChatSummary(uploadId) {
  const res = await axios.get(`${API}/chat/${uploadId}/summary`);
  return res.data;
}

export async function getMessages(uploadId) {
  const res = await axios.get(`${API}/chat/${uploadId}/messages`);
  return res.data;
}

export async function askQuestion(uploadId, question) {
  const res = await axios.post(`${API}/chat/${uploadId}/messages`, { question });
  return res.data;
}
